// extracted by mini-css-extract-plugin
export default {"StrollerDetailRating":"xi_a bhf_a bhf_x","StrollerDetailRating__muted":"xi_b bhf_fm"};